import React, {useCallback, useMemo} from "react";
import {StyledButton} from "../components/index.jsx";
import {Result} from "antd";
import {NotFoundPageImage} from "../images/Images";
import "./not-found-page.css";
import {getThemeByOrigin} from "../utils.js";

export const NotFoundPage = ({history}) => {
    const onNavigateHomeClick = useCallback(() => {
        history.goBack();
    }, [history]);

    const notFoundImg = useMemo(() => {
        const theme = getThemeByOrigin(window.location.origin);
        return NotFoundPageImage[theme] || NotFoundPageImage.image;
    }, []);

    return (
        <Result
            className="not-found-page"
            icon={<img src={notFoundImg} alt="page_not_found_image" />}
            style={{marginTop: 40}}
            title="אופס.. הלינק אליו הגעת כבר לא עדכני"
            subTitle={
                <div className="not-found-description">
                    <span>,מתנצלים זה לא אתם זה אנחנו</span>
                    <span>למעבר לדף בית לחצו כאן</span>
                </div>
            }
            extra={
                <StyledButton className="back-home-btn" onClick={onNavigateHomeClick}>
                    חזרה
                </StyledButton>
            }
        />
    );
};
